<template>
  <div>
    <Form  class="signForm" > 
            <h3>
                {{$t('verifyStep4')}}
            </h3>
            <div class="signCheck">
                <Checkbox v-model="checked"></Checkbox>
                <p>
                    {{$t('SignatureDeclaration1')}}
                    <a target="_blank" href=" https://www.ecmarkets.co.uk/wp-content/uploads/2021/03/Terms_of_Business_EC_Markets_Retail_clients_-_October_2020_F2.pdf">{{$t('SignatureDeclaration2')}}</a>
                      {{$t('SignatureDeclaration3')}}
                    <a href="https://www.ecmarkets.co.uk/wp-content/uploads/2021/03/EC-Markets-Risk-Disclosure-03-2021.pdf" target="_blank" >{{$t('SignatureDeclaration4')}}</a>,
                    <a href="https://www.ecmarkets.co.uk/wp-content/uploads/2021/03/EC-Markets-Order-Execution-Summary-03-2021.pdf" target="_blank" >{{$t('SignatureDeclaration5')}}</a>,
                    <a href="https://www.ecmarkets.co.uk/wp-content/uploads/2021/03/EC-Markets-Conflicts-Policy-Summary-03-2021.pdf" target="_blank" >{{$t('SignatureDeclaration6')}}</a>,
                    <a href="https://www.ecmarkets.co.uk/wp-content/uploads/2021/04/EC-Markets-Client-Categorisation-Policy-2021.pdf" target="_blank" >{{$t('SignatureDeclaration7')}} & </a> 
                    <a href="https://www.ecmarkets.co.uk/wp-content/uploads/2021/04/EC-Markets-Privacy-Policy-2021.pdf" target="_blank" >{{$t('SignatureDeclaration8')}}</a>{{$t('SignatureDeclaration9')}}
                </p>
                
            </div>
            <p >
                {{$t('SignatureDeclaration10')}}
            </p>
            <FormItem class="itemBtns">
                <Button type="primary" class="formBtn"  @click="back">{{$t('back')}}</Button>
                <Button type="primary" class="formBtn"  @click="next">{{$t('next')}}</Button>
            </FormItem>
    </Form>
    <loading :isSpinShow="loading"></loading>
  </div>
</template>

<script>
// @ is an alias to /src
import {mapState} from 'vuex'
import Loading from '@/components/Loading.vue';



export default {
  name: 'Home',
  components: {
    Loading
  },
  data(){
    return{
        checked:false,
        loading:false
    }
    
  },
    computed: {
        ...mapState(['lang','userInfo'])
    },
    created(){
    },
    methods:{
        next(){
            
                if (this.checked) {
                    this.loading = true
                    const data = {
                        useid:this.userInfo.userID
                    }
                    this.$axios.post('/api/UserQuestion/SignatureDeclaration', data)
                    .then(async (res) => {
                        // console.log(res)
                        if(res.data.status == 1){
                            if(res.data.obj.identityStatus == 3){
                                this.$emit('saveSteps',3)
                                sessionStorage.setItem('idCheckResultStatus',3)
                                this.$router.push({ path:'/verifyError'})
                            }else{
                                let _this = this
                                _this.$axios.get('/api/UserQuestion/CompelteRegistration')
                                .then(async (ress) => {
                                    // console.log(res)
                                    if(ress.data.status == 1){
                                        _this.$Message.success(this.$t('saveSucccess'))
                                        _this.$emit('changeSteps',4)
                                        _this.$emit('saveSteps',4)

                                        // this.$Message.success(this.$t('loginsuccess'))
                                        // this.$store.commit('setToken', res.data.obj.token)
                                        // this.$store.commit('setUserInfo', res.data.obj.userInfo)
                                        // this.$router.push({ path:'/myAccount'})
                                    }else{
                                        _this.$Message.error(ress.data.msg)
                                    }
                                })
                                .catch((err) => this.$Message.error(err.data.msg))
                            }
                            
                            // this.$Message.success(this.$t('saveSucccess'))
                            // this.$emit('changeSteps',5)
                            // this.$Message.success(this.$t('loginsuccess'))
                            // this.$store.commit('setToken', res.data.obj.token)
                            // this.$store.commit('setUserInfo', res.data.obj.userInfo)
                            // this.$router.push({ path:'/myAccount'})
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => this.$Message.error(err.data.msg))
                    .finally(() => this.loading = false)

                } else {
                    this.$Message.error(this.$t('signerror'));
                }
        },
        back(){
            this.$emit('changeSteps',2)
        }
    }
}
</script>
<style lang="less">
.verify{
    width: 1440px;
    margin: 0 auto;
    height: 100%;
    position: relative;
    
    .signForm{
        h3{
            display: block;
            width: 100%;
            position: relative;
            margin-bottom: 20px;
            padding-left: 20px;
            font-size: 18px;
            color: #332c2b;
            font-weight: normal;
        }
        h3::before{
            content: "";
            position: absolute;
            left: 0px;
            top: 50%;
            width: 8px;
            height: 8px;
            background-color: #e32b3a;
            border-radius: 4px;
            transform: translateY(-50%);
            -webkit-transform: translateY(-50%);
        }
        .signCheck{
            position: relative;
            p{
                text-indent: 30px;
                margin-bottom: 20px;
                a{
                    color: #e32b3a;
                    text-decoration: underline;
                }
            }
            label{
                position: absolute;
                top: 0;
                left: 0;
            }
        }
        p{
            margin-bottom: 20px;
        }
    }
}
</style>
